import { cn } from "@/lib/cn";

const OPTIONS: {
  key: "all" | "mentions" | "none";
  title: string;
  text: string;
}[] = [
  {
    key: "all",
    title: "All comments",
    text: "You’ll be notified about all new comment activity",
  },
  {
    key: "mentions",
    title: "Comments for you",
    text: "You’ll be notified about @mentions and threads involving you",
  },
  {
    key: "none",
    title: "None",
    text: "We’ll add a badge in this document but won’t send you notifications",
  },
];
export const Main = ({
  selected,
  setSelected,
}: {
  selected: string;
  setSelected: (value: "all" | "mentions" | "none") => void;
}) => {
  return (
    <div className="tw-space-y-6 tw-p-6 tw-pb-12">
      {OPTIONS.map((option) => (
        <div
          key={option.key}
          onClick={() => setSelected(option.key)}
          className="tw-flex tw-cursor-pointer tw-items-center"
        >
          <span
            className={cn(
              "tw-mr-4 tw-block tw-size-5 tw-shrink-0 tw-rounded-full tw-border-2 tw-border-solid tw-border-blue-100",
              {
                "tw-border-[6px] tw-border-primary-base":
                  selected === option.key,
              },
            )}
          ></span>
          <div>
            <span className="tw-mb-2 tw-block tw-font-sans tw-text-[13px]/tight tw-font-bold tw-text-blue-base">
              {option.title}
            </span>
            <span className="tw-block tw-font-sans tw-text-[13px]/normal tw-font-normal tw-text-blue-800">
              {option.text}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
};
